
const Privacypolicy = () => {
    return (
        <>
            <div className='container mx-auto'>
                <h1 className="text-xl lg:text-2xl font-bold text-gray-800 mb-6 mt-5">
                    Privacy Policy</h1>
                <h3 className="text-l lg:text-xl font-bold text-gray-800 mb-6 mt-5">Introduction</h3>
                <p>Welcome to our Events Booking App! This Privacy Policy explains how we collect, use, and protect your
                    personal information when you use our app. By using our app, you agree to the terms of this Privacy Policy.
                    Information We Collect</p>

                <p>We collect the following information from users:</p>
                <ul>
                    <li>Name: We collect your name to create and personalize your account.</li>
                    <li>Address: We collect your address to facilitate event bookings and improve our services.</li>
                    <li>Mobile Number: We collect your mobile number to send event notifications and updates.</li>
                </ul>
                <h3 className="text-l lg:text-xl font-bold text-gray-800 mb-6 mt-5">How We Use Your Information</h3>
                <p>We use your information for the following purposes:</p>
                <ul>
                    <li>Account Creation: We use your name, address, and mobile number to create and manage your account.</li>
                    <li>Event Bookings: We use your information to facilitate event bookings and provide event-related services.</li>
                    <li>Communication: We may use your mobile number to send event notifications and updates.</li>
                    <li>Improvement: We analyze user data to improve our app and services.</li>
                </ul>
                <h3 className="text-l lg:text-xl font-bold text-gray-800 mb-6 mt-5">Account Deletion</h3>
                <p>If you choose to delete your account, we will permanently remove your personal information from our system.
                    You can request account deletion by contacting our support team.</p>
                <h3 className="text-l lg:text-xl font-bold text-gray-800 mb-6 mt-5">Data Security</h3>
                <p>We take data security seriously. Your information is stored securely,
                    and we follow industry best practices to protect it.</p>
                <h3 className="text-l lg:text-xl font-bold text-gray-800 mb-6 mt-5">Changes to Privacy Policy</h3>
                <p>We may update this Privacy Policy from time to time. Please review it periodically for any changes.</p>
                <p>If you have any questions or concerns about our Privacy Policy, please contact us at info@ramadharmapracharasabha.com.</p>
                <hr></hr>
                <p>Last updated: 01/06/2026</p>
            </div>
        </>
    );
};

export default Privacypolicy;